import React from 'react';

const About = () => (
  <>
    <section className="py-5 text-white text-center" style={{ background: 'linear-gradient(135deg, #002868, #1a56db)' }}>
      <div className="container py-4">
        <h1 className="fw-bold">About EGB Systems</h1>
        <p className="lead" style={{ color: '#cbd5e1' }}>Leading the way in innovative technology solutions</p>
      </div>
    </section>

    <section className="py-5 bg-white">
      <div className="container py-4">
        <div className="row align-items-center g-5">
          <div className="col-12 col-lg-6">
            <div className="rounded-4 d-flex align-items-center justify-content-center" style={{ height: 350, background: 'linear-gradient(135deg, #dbeafe, #e0e7ff)', fontSize: 80 }}>🏢</div>
          </div>
          <div className="col-12 col-lg-6">
            <span className="badge bg-primary bg-opacity-10 text-primary px-3 py-2 mb-3">ABOUT EGB</span>
            <h2 className="fw-bold mb-3">Transforming E-Business with Strategic Solutions</h2>
            <p className="text-muted">EGB Systems and Solutions, Inc. is a leading provider of IT solutions. We specialize in delivering innovative technology solutions that help businesses grow and succeed in the digital age.</p>
            <p className="text-muted">Our visionary business approach combined with years of experience empowers us with economic leverage across diverse business sectors.</p>
            <div className="row g-3 mt-3">
              {[{ icon: '🏅', label: 'ISO 9001:2000 Certified' }, { icon: '🏛️', label: 'GSA Contract Holder' }, { icon: '📊', label: 'INC 500 | Rank #213' }, { icon: '⭐', label: 'CMMI Level 5' }].map(item => (
                <div key={item.label} className="col-6">
                  <div className="d-flex align-items-center gap-2 p-2 rounded bg-light">
                    <span style={{ fontSize: 20 }}>{item.icon}</span>
                    <span className="small fw-semibold">{item.label}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>

    <section className="py-5 bg-light">
      <div className="container py-4">
        <div className="text-center mb-5">
          <h2 className="fw-bold">Our Values</h2>
        </div>
        <div className="row g-4 text-center">
          {[{ icon: '💡', title: 'Innovation', desc: 'Continuously pushing boundaries with cutting-edge technology.' }, { icon: '🤝', title: 'Integrity', desc: 'Building trust through transparency and honest partnerships.' }, { icon: '🎯', title: 'Excellence', desc: 'Delivering the highest quality in every project we undertake.' }, { icon: '🌍', title: 'Global Reach', desc: 'Serving clients across 15+ countries worldwide.' }].map((v, i) => (
            <div key={i} className="col-12 col-sm-6 col-lg-3">
              <div className="card border-0 shadow-sm h-100 p-3">
                <div style={{ fontSize: 40 }} className="mb-3">{v.icon}</div>
                <h5 className="fw-bold">{v.title}</h5>
                <p className="text-muted small">{v.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  </>
);

export default About;
